<template>
  <v-container class="noMargin" style="padding-top: 26px !important;">
    <v-layout row wrap v-if="objAuthorize.privileges.indexOf('VENDOR_REPORT') !== -1">
      <v-flex lg12>
        <div class="pageTitle">
          <h2>Purchase Order Report</h2>
        </div>
        <!--<v-btn @click.prevent="fncExportSalesOrder" class="elevation-5" color="info"><img src="../../shared/assets/images/icons/csv.svg" class="customIcon" width="16" />EXPORT TO CSV</v-btn>-->
        <v-progress-circular v-show="soExcelLoading == true" style="display: block; float: left !important;margin-left: 52% !important; margin-top: 12px;" indeterminate :width="3" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>
        <div class="reportButtons">
        <!--<v-btn v-show="soExcelLoading == false" @click.prevent="fncExportSalesOrder" class="elevation-5" color="info"><i class="material-icons">file_copy</i>EXPORT TO EXCEL</v-btn>-->
        <v-btn @click.prevent="fncShowSalesOrderColumns" class="elevation-5" color="info"><i class="material-icons">view_columns</i>MANAGE COLUMNS</v-btn>
        <v-btn @click.prevent="fncReloadSalesOrder" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

  import { mapGetters } from 'vuex';
  import router from '@/router';

  export default {
    name: 'RoleHeader',
    data () {
      return {
        soSearch: window.localStorage.soSearch != undefined && window.localStorage.soSearch != null ? window.localStorage.soSearch : '',
        reportDate: window.localStorage.soDate != undefined && window.localStorage.soDate != null ? this.setDates() : '',
        objVendor: window.localStorage.soVendors != undefined && window.localStorage.soVendors[0] != null ? window.localStorage.soVendors : ['all'],
        objStore: window.localStorage.soStores != undefined && window.localStorage.soStores[0] != null ? window.localStorage.soStores : ['all'],
        objStatus: window.localStorage.soStatus != undefined && window.localStorage.soStatus[0] != null ? window.localStorage.soStatus : ['all']
      }
    },
    methods: {
      setDates() {
        //return window.localStorage.reportDates.split(',');
        if( window.localStorage.reportDates != null ) {
          return window.localStorage.reportDates.split(',');
        } else {
          return [];
        }
      },
      fncReloadSalesOrder() {
        // this.$store.dispatch('fncPopulateSalesOrders', true);
        router.replace('/reports/sales-order-reports?p=1');
        window.location.reload();
      },
      fncVendorAdd() {
        var modalDetails = { title: 'Add Vendor', component: 'modal-vendor-add', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncReloadVendors() {
        this.$store.commit('fncEmptyVendors');
        this.$store.dispatch({
          type: 'fncPopulateVendors',
          reload: true
        })
      },
      fncShowSalesOrderColumns() {
        var modalDetails = { title: 'Filter Purchase Order Columns', component: 'modal-filter-so-columns', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncExportSalesOrder() {


        if( this.objVendor && this.objVendor[0] != 'all' ) {
          var vendorParse = JSON.parse(this.objVendor);
        } else {
          var vendorParse = [];
        }

        if( this.objStore && this.objStore[0] != 'all' ) {
          var storeParse = JSON.parse( this.objStore );
        } else {
          var storeParse = [];
        }

        if( this.objStatus && this.objStatus[0] != 'all' ) {
          var statusParse = JSON.parse( this.objStatus );
        } else {
          var statusParse = [];
        }

        if( window.localStorage.soDate ) {
          var soDates = window.localStorage.soDate.split(',');
        } else {
          var soDates = [];
        }

        this.$store.commit('setSoExcelLoading', true);
        this.$store.dispatch({
          type: 'fncDoSoExcel',
          reportDate: soDates,
          // reportDate: this.reportDate,
          objVendor: vendorParse,
          objStore: storeParse,
          objStatus: statusParse,
          columns: this.soColumns,
          // search: this.soSearch
          search: ''
        });

        /*var reportData = [];

        var reportHeaders = [];

        for (var h in this.soColumns) {
          if (this.soColumns[h].checked == true) {
            if (this.soColumns[h].label == 'Total' && this.objAuthorize.privileges.indexOf('VENDOR_NO_PRICE') == -1) {
              reportHeaders.push(this.soColumns[h].label);
            } else {
              if (this.soColumns[h].label != 'Total') {
                reportHeaders.push(this.soColumns[h].label);
            }
            }
          }
        }

        if( this.salesOrderListFilter.length > 0 ) {
          var maxCount = 0;
          var maxInstallationCount = 0;
          for (var s in this.salesOrderListFilter) {
            var newCount = this.salesOrderListFilter[s].productNames.length;
            if( newCount > maxCount){
              maxCount = newCount;
            }

              for( i in this.salesOrderListFilter[s].items ) {
                var lineData = this.salesOrderListFilter[s].items[i].line_item_data
                if( lineData.indexOf('installation_product_description_5') != -1 && maxInstallationCount < 5 ) {
                  maxInstallationCount = 5;
                }
                if( lineData.indexOf('installation_product_description_4') != -1 && maxInstallationCount < 4 ) {
                  maxInstallationCount = 4;
                }
                if( lineData.indexOf('installation_product_description_3') != -1 && maxInstallationCount < 3 ) {
                  maxInstallationCount = 3;
                }
                if( lineData.indexOf('installation_product_description_2') != -1 && maxInstallationCount < 2 ) {
                  maxInstallationCount = 2;
                }
                if( lineData.indexOf('installation_product_description_1') != -1 && maxInstallationCount < 1 ) {
                  maxInstallationCount = 1;
                }
              }

          }
          var p = 1;
          while( p <= maxInstallationCount ) {
            reportHeaders.push('INSTALLATION PRODUCT NAME ' + p);
            p++;
          }
          var maxCountLoop = maxCount + 1;
          var n = 1;
          while( n < maxCountLoop ) {
            reportHeaders.push('PRODUCT NAME ' + n);
            reportHeaders.push('PRODUCT CODE ' + n);
            n++;
          }
        }

        reportData.push( reportHeaders );

        for (var s in this.salesOrderListFilter ) {
          var singleData = [];
          for (var h in this.soColumns) {
            if (this.soColumns[h].checked == true) {
              if (this.soColumns[h].id == 'items') {
                //reportData += this.salesOrderListFilter[s].items.length + ',';
                singleData.push(this.salesOrderListFilter[s].items.length);
              } else if (this.soColumns[h].id == 'totalPrice') {
                if (this.objAuthorize.privileges.indexOf('VENDOR_NO_PRICE') == -1 ) {
                  if (this.objAuthorize.privileges.indexOf('VENDOR_COST_PRICE') != -1) {

                    var csvTotal = 0;
                    for (var k in this.salesOrderListFilter[s].items) {
                      var price = 0;
                      var lineData = JSON.parse(this.salesOrderListFilter[s].items[k].line_item_data);
                      if (lineData.cost_price != null) {
                        price = lineData.cost_price;
                      } else if( this.globalModalParams != undefined && this.globalModalParams.details != undefined && this.globalModalParams.details != null ) {
                        price = this.globalModalParams.details.items[k].price
                      } else {
                        price = this.salesOrderListFilter[s].items[k].price;
                      }
                      var addPrice = (parseFloat(parseFloat(price) - parseFloat(this.salesOrderListFilter[s].items[k].discount)).toFixed(2) * this.salesOrderListFilter[s].items[k].quantity_calc).toFixed(2);
                      csvTotal = parseFloat(csvTotal) + parseFloat(addPrice);
                    }

                    csvTotal = parseFloat(csvTotal).toFixed(2);

                  } else if (this.objAuthorize.privileges.indexOf('VENDOR_FULL_PRICE') != -1) {
                    //var csvTotal = parseFloat(this.salesOrderListFilter[s].total).toFixed(2);

                    var csvTotal = 0;
                    for (var k in this.salesOrderListFilter[s].items) {
                      var price = 0;
                      price = this.salesOrderListFilter[s].items[k].price;
                      var addPrice = (parseFloat(parseFloat(price) - parseFloat(this.salesOrderListFilter[s].items[k].discount)).toFixed(2) * this.salesOrderListFilter[s].items[k].quantity_calc).toFixed(2);
                      csvTotal = parseFloat(csvTotal) + parseFloat(addPrice);
                    }

                    csvTotal = parseFloat(csvTotal).toFixed(2);
                  }

                  singleData.push( parseFloat(csvTotal).toFixed(2) );
                  //reportData += parseFloat(csvTotal).toFixed(2) + ',';
                }
              } else if( this.soColumns[h].id == 'serviceType') {

                var objItem = this.salesOrderListFilter[s];
                var serviceType = '';

                if( objItem.customer != objItem.createdBy ) {
                  serviceType = 'Assisted';
                } else if( objItem.customer == objItem.createdBy ) {
                  if( objItem.email != undefined && objItem.email.indexOf('@builders') != -1 ) {
                    serviceType = 'ASM Issue';
                  } else {
                    serviceType = 'Self Service';
                  }
                } else {
                  serviceType = 'Unknown';
                }
                singleData.push( serviceType );
              } else if( this.soColumns[h].id == 'soBranch') {

                if( this.salesOrderListFilter[s].items != undefined ) {

                  var item = this.salesOrderListFilter[s];
                  var parsedItem = JSON.parse( item.items[0].line_item_data );
                  if( parsedItem.store_id != undefined && parsedItem.store_id != null ) {
                    for( var b in this.branchList ) {
                      if( this.branchList[b].code == parsedItem.store_id ) {
                        singleData.push( this.branchList[b].name );
                      }
                    }
                  } else {
                    singleData.push('N/A');
                  }
                } else {
                  singleData.push('N/A');
                }

              } else if( this.soColumns[h].id == 'soGlassSize') {
                var items = this.salesOrderListFilter[s].items;
                if( items != 'undefined' && items != undefined && items[0].quantity != undefined ) {
                  var specString = '';
                  for( var i in items ) {
                    if( items[i].spec != null && items[i].spec.indexOf('size-glass') != -1 ) {
                      specString = items[i].spec;
                    }
                  }
                  if( specString != '' ) {
                    var specSplit = specString.split("<span class='size-glass'>");
                    if( specSplit.length == 2 ) {
                      var glassSize = specSplit[1].split('</span>');
                      singleData.push(glassSize[0]);
                    } else {
                      singleData.push('N/A');
                    }
                  } else {
                    singleData.push('N/A');
                  }
                } else {
                  singleData.push('N/A');
                }

              } else if( this.soColumns[h].id == 'soGlassType') {
                var items = this.salesOrderListFilter[s].items;
                if( items != 'undefined' && items != undefined && items[0].quantity != undefined ) {
                  var specString = '';
                  for( var i in items ) {
                    if( items[i].spec != null && items[i].spec.indexOf('type-glass') != -1 ) {
                      specString = items[i].spec;
                    }
                  }
                  if( specString != '' ) {
                    var specSplit = specString.split("<span class='type-glass'>");
                    if( specSplit.length == 2 ) {
                      var glassType = specSplit[1].split('</span></td>');
                      var detailsSplit = glassType[0].split("</span><span class='glasstype'>");
                      singleData.push(detailsSplit[0].replace("<span class='size'>", '') + ' ' + detailsSplit[1].replace('</span>', ''));
                    } else {
                      singleData.push('N/A');
                    }
                  } else {
                    singleData.push('N/A');
                  }
                } else {
                  singleData.push('N/A');
                }
              } else if( this.soColumns[h].id == 'soQty') {

                var items = this.salesOrderListFilter[s].items;
                if( items != 'undefined' && items != undefined && items[0].quantity != undefined && items[0].quantity != null ) {
                  singleData.push( items[0].quantity );
                } else {
                  singleData.push('N/A');
                }
              } else if( this.soColumns[h].id == 'installationDate') {
                var installationDate = 'N/A';
                for( i in this.salesOrderListFilter[s].items ) {

                  var lineData = this.salesOrderListFilter[s].items[i].line_item_data
                  if( lineData.indexOf('installation_appointment_date_start') != -1 ) {
                    var timeSplit = lineData.split('installation_appointment_date_start');
                    var newSplit = timeSplit[1].replace(/"/g, "");
                    newSplit = newSplit.replace(/'/g, "");
                    newSplit = newSplit.replace(/:/g, "");
                    newSplit = newSplit.replace(/\//g,'');
                    newSplit = newSplit.split('\\');
                    newSplit = newSplit[0].split(',');
                    installationDate = newSplit[0];
                  }
                }

                singleData.push( installationDate );
              } else if( this.soColumns[h].id == 'installationDescription') {

                var installationDescription = 'N/A';
                for( i in this.salesOrderListFilter[s].items ) {

                  var lineData = this.salesOrderListFilter[s].items[i].line_item_data
                  if( lineData.indexOf('installation_product_description_1') != -1 ) {
                    var timeSplit = lineData.split('installation_product_description_1');
                    var newSplit = timeSplit[1].replace(/"/g, "");
                    newSplit = newSplit.replace(/'/g, "");
                    newSplit = newSplit.replace(/:/g, "");
                    newSplit = newSplit.replace(/\//g,'');
                    newSplit = newSplit.split('\\');
                    newSplit = newSplit[0].split(',');
                    installationDescription = newSplit[0];
                  }
                }

                singleData.push( installationDescription );
              } else if( this.soColumns[h].id == 'onsiteTime') {
                var statusName = '';
                for( var z in this.soStatusList ) {
                  if( this.soStatusList[z].fs_on_site == 'Yes' || this.soStatusList[z].fs_on_site == '1' ) {
                    statusName = this.soStatusList[z].description;
                  }
                }
                var toReturn = 'N/A';
                if( this.manufacturerAudits[item.quoteId] != null ) {
                  if( this.manufacturerAudits[item.quoteId][statusName] != null ) {
                    toReturn = this.manufacturerAudits[item.quoteId][statusName].time;
                  }
                }
                singleData.push( toReturn );
              } else if( this.soColumns[h].id == 'cancellationReason') {

                var statusName = '';
                for( var z in this.soStatusList ) {
                  if( this.soStatusList[z].fs_job_cancelled == 'Yes' || this.soStatusList[z].fs_job_cancelled == '1' ) {
                    statusName = this.soStatusList[z].description;
                  }
                }
                var toReturn = 'N/A';
                if( this.manufacturerAudits[item.quoteId] != null ) {
                  if( this.manufacturerAudits[item.quoteId][statusName] != null ) {
                    toReturn = this.manufacturerAudits[item.quoteId][statusName].data;
                  }
                }
                singleData.push( toReturn );
              } else if( this.soColumns[h].id == 'jobComplete') {
                var statusName = '';
                for( var z in this.soStatusList ) {
                  if( this.soStatusList[z].fs_job_complete == 'Yes' || this.soStatusList[z].fs_job_complete == '1' ) {
                    statusName = this.soStatusList[z].description;
                  }
                }
                var toReturn = 'N/A';
                if( this.manufacturerAudits[item.quoteId] != null ) {
                  if( this.manufacturerAudits[item.quoteId][statusName] != null ) {
                    toReturn = this.manufacturerAudits[item.quoteId][statusName].time;
                  }
                }
                singleData.push( toReturn );
              } else if( this.soColumns[h].id == 'customerRating') {
                if( this.salesOrderListFilter[s].customerRating == '0' || this.salesOrderListFilter[s].customerRating == '' ) {
                  singleData.push('N/A');
                } else {
                  singleData.push(this.salesOrderListFilter[s].customerRating);
                }
              }  else {
                singleData.push( this.salesOrderListFilter[s][this.soColumns[h].id] );
              }
            }
         }
          var productNames = this.salesOrderListFilter[s].productNames;
          var productCodes = this.salesOrderListFilter[s].productCodes;

          //for( i in this.salesOrderListFilter[s].items ) {
            var lineData = this.salesOrderListFilter[s].items[0].line_item_data
            var z = 1;
            while( z <= maxInstallationCount ) {
              var prodDescription = 'N/A';
              if( lineData.indexOf('installation_product_description_'+z) != -1 ) {
                var timeSplit = lineData.split('installation_product_description_'+z);
                var newSplit = timeSplit[1].replace(/"/g, "");
                newSplit = newSplit.replace(/'/g, "");
                newSplit = newSplit.replace(/:/g, "");
                newSplit = newSplit.replace(/\//g,'');
                newSplit = newSplit.split(',');
                prodDescription = newSplit[0];
              }
              if( prodDescription == '' ) {
                singleData.push('N/A');
              } else {
                singleData.push(prodDescription);
              }
              z++;
            }
          //}

          var maxCountLoop = productNames.length;
          var n = 0;
          while( n < maxCountLoop ) {
            singleData.push(productNames[n]);
            singleData.push(productCodes[n]);
            n++;
          }

          reportData.push( singleData );

       }

      this.$store.dispatch('fncReturnExcel', reportData);*/

      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'soColumns',
        'salesOrderList',
        'salesOrderListFilter',
        'branchList',
        'soStatusList',
        'manufacturerAudits',
        'soExcelLoading'
      ])
    },
    beforeMount() {
      this.$store.dispatch( 'fncGetSalesOrderColumns', this.objAuthorize );
      this.$store.dispatch('fncPopulateBranches');
      //this.$store.commit('fncSetSalesOrderColumns', this.objAuthorize);
    }
  }
</script>

<style scoped>
  /* @import '../../shared/assets/css/shared.css';*/
</style>
